module.exports = __webpack_public_path__ + "img/kyouzai_japanese.f2c584ff.png";